import styled from "styled-components";

const Button = styled.button`
  background-color: #464e5e;
  border: none;
  border-radius: 16px;
  color: #ffffff;
  font-size: 24px;
  font-weight: 700;
  padding: 22px;
`;

export default Button;
